export default __webpack_public_path__ + "static/media/le_touquet10.5f3b63b7.jpg";